export default "__VITE_ASSET__Cfsq4m2a__"